import { render, staticRenderFns } from "./Envios.vue?vue&type=template&id=5b75930d&scoped=true"
import script from "./Envios.vue?vue&type=script&lang=js"
export * from "./Envios.vue?vue&type=script&lang=js"
import style0 from "./Envios.vue?vue&type=style&index=0&id=5b75930d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b75930d",
  null
  
)

export default component.exports